export default "__VITE_ASSET__8CIKTRst__"